enum EventKey {
  RequestForbidden = 'REQUEST_FORBIDDEN',
  HandleCustomError = 'HANDLE_CUSTOM_ERROR',
  HideErrorToast = 'HIDE_ERROR_TOAST',
}

export default EventKey;
